import { ReactElement, MouseEvent, useCallback } from 'react';
import { FormControl } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { ButtonFileUploadProps } from './types';
import { ButtonFileUploadInput, ButtonFileUploadInputLabel } from './styles';

const ButtonFileUpload = ({
  label = 'Subir archivos',
  accept = 'image/*, application/pdf',
  multiple = false,
  disabled = false,
  color,
  variant,
  startIcon,
  fullWidth = false,
  onChange,
  loading = false,
}: ButtonFileUploadProps): ReactElement => {
  const resetInput = useCallback((event: MouseEvent<HTMLInputElement>) => {
    event.currentTarget.value = '';
  }, []);

  return (
    <FormControl fullWidth={fullWidth}>
      <ButtonFileUploadInput
        id="button-file-upload"
        type="file"
        inputProps={{ accept, multiple, onClick: resetInput }}
        disabled={disabled}
        onChange={onChange}
      />

      <ButtonFileUploadInputLabel htmlFor="button-file-upload">
        <LoadingButton
          component="span"
          variant={variant}
          color={color}
          startIcon={startIcon}
          loading={loading}
          disabled={disabled}
          sx={{ height: '100%' }}
        >
          {label}
        </LoadingButton>
      </ButtonFileUploadInputLabel>
    </FormControl>
  );
};

export default ButtonFileUpload;
